import { FC, useCallback, useEffect, useMemo } from 'react';
import cls from 'classnames';
import { useAtomValue } from 'jotai';
import { $SimpleCTAModalShow } from '~/models/portal/simple-cta-modal';
import { useTranslation } from 'react-i18next';
import { useResetAtom } from 'jotai/utils';
import { FixBodyUtil } from '~/utils/fix-body';

import './style.scss';

export const SimpleCtaModal: FC = () => {
  const config = useAtomValue($SimpleCTAModalShow);
  const closeModal = useResetAtom($SimpleCTAModalShow);
  const { t } = useTranslation();

  const visibleCls = useMemo(
    () => ({
      shown: Boolean(config),
      hidden: !config,
    }),
    [config],
  );

  const currentPosition = useMemo(() => {
    if (!config) {
      return '';
    }

    const position = config.currentPosition;
    return Array.isArray(position) ? position[0] + position[1] : position;
  }, [config]);

  const additionalParams = useMemo(() => {
    if (!config || !config.additionalParams) {
      return {};
    }

    return config.additionalParams;
  }, []);

  const handleClickConfirm = useCallback(() => {
    if (!config) {
      return;
    }

    window.Tea('wap_click', {
      current_position: currentPosition,
      is_cta: 1,
      page_click_id: config.pageClickId,
      click_result: 'install',
      ...additionalParams,
    });
    config.handleClickConfirm();
    closeModal();
  }, [config, closeModal]);

  const handleClickCancel = useCallback(() => {
    if (!config) {
      return;
    }

    window.Tea('wap_click', {
      current_position: currentPosition,
      page_click_id: config.pageClickId,
      click_result: 'cancel',
      ...additionalParams,
    });
    config.handleClickCancel?.();
    closeModal();
  }, [config, closeModal]);

  useEffect(() => {
    if (config) {
      window.Tea('wap_cta_show', {
        current_position: currentPosition,
        ...additionalParams,
      });

      FixBodyUtil.fix();
    } else {
      FixBodyUtil.restore();
    }
  }, [config]);

  return (
    <div className={cls('simple-cta-modal', visibleCls)}>
      <div className={cls('simple-cta-modal-mask', visibleCls)} />
      <div className={cls('simple-cta-modal-container', visibleCls)}>
        <div className="simple-cta-modal-body">{config ? config.body : ''}</div>
        <div className="simple-cta-modal-footer">
          <div className="simple-cta-modal-cancel-button" onClick={handleClickCancel}>
            {t('seo_landing_modal_btn_later')}
          </div>
          <div className="simple-cta-modal-install-button" onClick={handleClickConfirm}>
            {t('seo_landing_modal_btn_open')}
          </div>
        </div>
      </div>
    </div>
  );
};
